module.exports = __webpack_public_path__ + "static/media/visual-studio-code.17a3905f.svg";